module.exports = __webpack_public_path__ + "static/media/agents_icon.72c4710a.svg";